(function () {
  "use strict";

  const data = getData();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  function run() {
    addStyle();
    addCompareBtnPDP();
    addComparePopup();
    handleEvents();
    assignCssVariables();
  }

  function addStyle() {
    let style = document.createElement("style");
    style = document.createElement("style");
    style.textContent = `
      body:has(.compare-popup.show) {
        overflow: hidden;
      }
      .compare-btn {
        width: 100%;
        margin-bottom: 1rem;
        padding: 12px;
        background: #fff;
        border: 2px solid #7A0000;
        color: #7A0000;
        font-weight: 700;
      }
      .compare-btn:active {
        transform: scale(0.98);
      }
      .compare-popup {
        --nav-height: 0px;
        display: none;
        position: fixed;
        inset: 0;
        width: 100%;
        height: calc(100dvh - var(--nav-height));
        margin-top: var(--nav-height);
        background: #fff;
        overflow: auto;
        z-index: 9999999;
      }
      .compare-popup-close-btn {
        position: fixed;
        top: calc(var(--nav-height) + 1rem);
        right: 1rem;
        display: flex;
        cursor: pointer;
        z-index: 3;
      }
      .compare-popup-close-btn svg {
        width: 30px;
        height: 30px;
      }
      .compare-popup-close-btn:active svg {
        transform: scale(0.95);
      }
      .compare-popup p {
        margin: 0;
      }
      .compare-popup p.title {
        width: 100%;
        margin-top: 1rem;
        text-align: center;
        font-size: 28px;
        font-weight: 700;
      }
      .compare-popup p.subtitle {
        width: 100%;
        text-align: center;
        font-size: 14px;
      }
      .compare-popup table {
        width: 100%;
        max-width: 800px;
        margin: 0 auto;
        table-layout: fixed;
      }
      .compare-popup table tr {
        background: #fff;
      }
      .compare-popup table tr.row_info {
        position: sticky;
        top: 0;
        z-index: 2;
      }
      .compare-popup table tr.row_price {
        position: sticky;
        top: var(--info-height);
        z-index: 1;
      }
      .compare-popup table tr.row_cta {
        position: sticky;
        top: calc(var(--info-height) + var(--price-height));
        z-index: 1;
      }
      .compare-popup table tr.row_cutoff {
        background: transparent;
      }
      .compare-popup table tr.row_cta {
        box-shadow: 0px 4px 2px -2px #00000040;
      }
      .compare-popup table td {
        padding: 0px 3px;
        vertical-align: middle;
      }
      .compare-popup table tr.row_price td,
      .compare-popup table tr.row_cta td,
      .compare-popup table tr.row_cutoff td {
        padding-block: 0.5rem;
      }
      .compare-popup table tr.row_info td,
      .compare-popup table tr.row_data td {
        vertical-align: top;
      }
      .compare-popup table tr > td:nth-child(3) {
        display: none;
      }
      .compare-popup table .row_image img {
        max-height: 250px;
        width: auto;
        display: block;
        margin: 0 auto;
      }
      .compare-popup table .info_wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }
      .compare-popup table .info_wrapper p:first-child {
        font-size: 14px;
      }
      .compare-popup table .info_wrapper p:nth-child(n+2) {
        font-size: 12px;
      }
      .compare-popup table .variant_wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        padding-block: 4px;
      }
      .compare-popup table .variant_wrapper .variant_model,
      .compare-popup table .variant_wrapper .variant_color {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: 8px;
        row-gap: 4px;
      }
      .compare-popup table .variant_wrapper .variant_model .item {
        display: block;
        padding: 6px 10px;
        background: #fff;
        color: #000;
        border: 1px solid black;
        cursor: pointer;
        font-size: 11px;
        text-align: center;
      }
      .compare-popup table .variant_wrapper .variant_model .item.active {
        background: #000;
        color: #fff;
      }
      .compare-popup table .variant_wrapper .variant_color .item {
        position: relative;
        width: 20px;
        height: 20px;
        border: 1px solid #000;
        border-radius: 100%;
        cursor: pointer;
      }
      .compare-popup table .variant_wrapper .variant_color .item.active:after {
        position: absolute;
        top: -4px;
        left: -4px;
        content: "";
        width: 26px;
        height: 26px;
        border-radius: 100%;
        border: 1px solid #000;
      }
      .compare-popup table .variant_wrapper .variant_color .item[data-color="Pearl White"] {
        background: url();
      }
      .compare-popup table .variant_wrapper .variant_color .item[data-color="Space Grey"] {
        background: url(https://cdn.shopify.com/s/files/1/1595/6213/files/1-SpaceGray.svg?v=1723997765&width=50);
      }
      .compare-popup table .price_wrapper {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: center;
        gap: 4px;
      }
      .compare-popup table .price_wrapper .price {
        color: #9b0202;
        font-size: 17px;
        font-weight: 700;
      }
      .compare-popup table .price_wrapper .compare_at_price {
        font-size: 13px;
        align-self: flex-end;
      }
      .compare-popup table .cta_wrapper a {
        width: 100%;
        padding: .5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #7a0000;
        background: #7a0000;
        color: #fff;
        font-weight: 600;
        font-size: 12px;
        text-align: center;
      }
      .compare-popup table .data_wrapper {
        padding-block: 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 8px;
      }
      .compare-popup table .data_wrapper img {
        max-width: 120px;
        max-height: 100px;
      }
      .compare-popup table .data_wrapper:empty {
        display: none;
      }
      .compare-popup table .data_wrapper p {
        font-size: 12px;
      }
      @media (min-width: 1024px) {
        .compare-btn {
          position: absolute;
          top: 0;
          right: 0;
          max-width: 180px;
          margin-bottom: 0;
        }
        .compare-popup p.title {
          font-size: 32px;
        }
        .compare-popup p.subtitle {
          font-size: 16px;
        }
        .compare-popup table td {
          padding-inline: 8px;
        }
        .compare-popup table tr > td:nth-child(3) {
          display: table-cell;
        }
        .compare-popup table .info_wrapper p:first-child {
          font-size: 20px;
        }
        .compare-popup table .info_wrapper p:nth-child(n+2) {
          font-size: 14px;
        }
        .compare-popup table .variant_wrapper .variant_model .item {
          padding: 8px 12px;
          font-size: 14px;
        }
        .compare-popup table .price_wrapper .price {
          font-size: 22px;
        }
        .compare-popup table .cta_wrapper a {
          padding: 13px 23px;
          font-size: 16px;
        }
        .compare-popup table .data_wrapper p b {
          font-size: 16px;
        }
        .compare-popup table .data_wrapper img {
          max-width: 200px;
          max-height: 150px;
        }
      }
    `;
    document.head.append(style);
  }

  function addCompareBtnPDP() {
    const button = document.createElement("button");
    button.classList.add("btn", "spec-button", "pdp-compare-btn");
    button.textContent = "Compare";
    button.addEventListener("click", function () {
      $(".compare-popup").toggleClass("show");
    });
    $(".nav2-content .spacer").after(button);
  }

  function addComparePopup() {
    const comparePopup = document.createElement("div");
    comparePopup.classList.add("compare-popup");
    comparePopup.innerHTML = `
      <div class="compare-popup-close-btn">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M183.1 137.4C170.6 124.9 150.3 124.9 137.8 137.4C125.3 149.9 125.3 170.2 137.8 182.7L275.2 320L137.9 457.4C125.4 469.9 125.4 490.2 137.9 502.7C150.4 515.2 170.7 515.2 183.2 502.7L320.5 365.3L457.9 502.6C470.4 515.1 490.7 515.1 503.2 502.6C515.7 490.1 515.7 469.8 503.2 457.3L365.8 320L503.1 182.6C515.6 170.1 515.6 149.8 503.1 137.3C490.6 124.8 470.3 124.8 457.8 137.3L320.5 274.7L183.1 137.4z"/></svg>
      </div>
      <div class="page-width">
        <p class="title">Compare Laundry Rack</p>
        <p class="subtitle">Discover your perfect laundry companion, choose the right laundry rack for a smarter, more effortless home.</p>
        <table class="compare-table">
          <tbody></tbody>
        </table>
      </div>
    `;
    document.body.append(comparePopup);

    fillComparePopup(comparePopup);

    return comparePopup;
  }

  function fillComparePopup(comparePopup) {
    const tbody = $(comparePopup).find("table tbody");

    for (const x in [...Array(16).keys()]) {
      const rowIndex = Number(x);
      const row = document.createElement("tr");
      tbody.append(row);

      switch (rowIndex) {
        case 0:
          $(row).addClass("row_image");
          break;
        case 1:
          $(row).addClass("row_info");
          break;
        case 2:
          $(row).addClass("row_variant");
          break;
        case 3:
          $(row).addClass("row_price");
          break;
        case 4:
          $(row).addClass("row_cta");
          break;
        case 5:
          $(row).addClass("row_cutoff");
          break;
        default:
          $(row).addClass("row_data");
          break;
      }

      for (const y in [...Array(2).keys()]) {
        const colIndex = Number(y);
        const cell = document.createElement("td");
        row.append(cell);

        const colData = Object.entries(data)[colIndex];
        const prodName = colData[0];
        const prodData = colData[1];

        const models = prodData.variants.models;
        const colors = prodData.variants.colors;

        if (rowIndex == 0) {
          cell.innerHTML = `
            <div class="image_wrapper">
              <img src="${prodData.image_url}" alt="" width="" height="" />
            </div>
          `;
        } else if (rowIndex == 1) {
          cell.innerHTML = `
            <div class="info_wrapper">
              <p>${prodName}</p>
              <p>${prodData.airflow}</p>
              <p>${prodData.type}</p>
            </div>
          `;
        } else if (rowIndex == 2) {
          cell.innerHTML = `
            <div class="variant_wrapper" data-product="${prodName}">
              <ul class="variant_model">
                ${models.map((n, i) => `<li class="item ${i == 0 ? "active" : ""}">${n}</li>`).join("")}
              </ul>
              <ul class="variant_color">
                ${colors.map((n, i) => `<li class="item ${i == 0 ? "active" : ""}" data-color="${n}"></li>`).join("")}
              </ul>
            </div>
          `;
        } else if (rowIndex == 3) {
          cell.innerHTML = `
            <div class="price_wrapper">
              <img width="20" height="20" src="//prismplus.sg/cdn/shop/t/35/assets/voucher-icon.svg?v=96074962922774460831765247161" />
              <span class="price">${theme.Currency.formatMoney(prodData.price)}</span>
              <s class="compare_at_price ${prodData.compare_at_price == 0 && "hide"}">${theme.Currency.formatMoney(prodData.compare_at_price)}</s>
            </div>
          `;
        } else if (rowIndex == 4) {
          cell.innerHTML = `
            <div class="cta_wrapper">
              <a href="${prodData.url}">Shop Now</a>
            </div>
          `;
        } else if (rowIndex == 5) {
          cell.innerHTML = ``;
        } else {
          let dataRowCount = rowIndex - 6;
          const filteredDetails = Object.fromEntries(
            Object.entries(prodData.details).filter(
              ([key, value]) => value !== null,
            ),
          );
          const curRow = Object.entries(filteredDetails)[dataRowCount];
          if (curRow) {
            const dKey = curRow[0];
            const dVal = curRow[1];

            const dataWrapper = document.createElement("div");
            dataWrapper.classList.add("data_wrapper", `data-${dKey}`);
            cell.append(dataWrapper);
            dataWrapper.innerHTML = getDetailsHtml(dKey, dVal);
          }
        }
      }
    }
  }

  function handleEvents() {
    const compareBtn = $(".compare-btn");
    const comparePopup = $(".compare-popup");
    const closeBtn = comparePopup.find(".compare-popup-close-btn");
    const variantWrapper = comparePopup.find(".variant_wrapper");

    compareBtn.on("click", function () {
      comparePopup.addClass("show");
    });
    closeBtn.on("click", function () {
      comparePopup.removeClass("show");
    });
    variantWrapper.find(".item").on("click", function () {
      $(this).siblings(".item").removeClass("active");
      $(this).addClass("active");
    });
    variantWrapper.on("click", function () {
      let variants = $(this)
        .find(".item.active")
        .map((i, el) => $(el).attr("data-color") || $(el).text())
        .get();
      const variant = variants.join(" / ");
      const index = $(this).closest("td").index();
      const prodName = $(this).closest(".variant_wrapper").attr("data-product");
      const imageUrl = data[prodName].images[variant];
      comparePopup
        .find(`.row_image td:nth-child(${index + 1}) img`)
        .attr("src", imageUrl);
    });
  }

  function assignCssVariables() {
    const comparePopup = $(".compare-popup")[0];

    setInterval(() => {
      comparePopup.style.setProperty(
        "--info-height",
        `${$(".compare-table .row_info").height()}px`,
      );
      comparePopup.style.setProperty(
        "--price-height",
        `${$(".compare-table .row_price").height()}px`,
      );
      comparePopup.style.setProperty(
        "--nav-height",
        `${$("#shopify-section-header").height()}px`,
      );
    }, 50);
  }

  function getDetailsHtml(dKey, dVal) {
    let html = ``;

    switch (dKey) {
      case "aeroFlexMotor":
        switch (dVal) {
          case 1:
            html = `<img class="image" src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/solaris_aeroflex.png?v=1776149268" alt="" width="" height="" /><p><b>7m/s AeroFlex Motor up to 4 Fans</b><br/>AeroFlex™ motor delivers 7m/s airflow with  60°C drying.</p>`;
            break;
          case 2:
            html = `<img class="image" src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/solaris_pro_aeroflex.png?v=1776149272" alt="" width="" height="" /><p><b>9m/s AeroFlex Motor up to 6 Fans</b><br/>Hyperion™ BLDC delivers 9 m/s airflow with 75°C fast drying.</p>`;
            break;
        }
        break;
      case "heater":
        switch (dVal) {
          case 1:
            html = `<img class="image" src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/solaris_heater.png?v=1776072511" alt="" width="" height="" /><p><b>60°C Heater</b><br/>20-40°C airflow Temperature depending on ambient temperature and humidity</p>`;
            break;
          case 2:
            html = `<img class="image" src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/solaris_pro_heater.png?v=1776072512" alt="" width="" height="" /><p><b>75°C Heater</b><br/>30-50°C airflow Temperature depending on ambient temperature and humidity</p>`;
            break;
        }
        break;
      case "connectApp":
        switch (dVal) {
          case 1:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SmartHomeApp.svg?v=1776217543" alt="" width="" height="" /><p><b>Smart Home App</b><br/>Control modes and schedule drying via the app.</p>`;
            break;
        }
        break;
      case "voiceControl":
        switch (dVal) {
          case 1:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/AIVoiceControl.svg?v=1776217543" alt="" width="" height="" /><p><b>Edge AI Voice Control</b><br/>Hands-free Control. Without Wi-Fi!</p>`;
            break;
        }
        break;
      case "aeroFlow":
        html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/AeroFlow.svg?v=1776217542" alt="" width="" height="" /><p><b>AeroFlow</b><br/>${dVal}</p>`;
        break;
      case "frame":
        html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Frame.svg?v=1776217543" alt="" width="" height="" /><p><b>Frame</b><br/>${dVal}</p>`;
        break;
      case "extendableRods":
        html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/ExtendableRods.svg?v=1776217543" alt="" width="" height="" /><p><b>Extendable Rods</b><br/>${dVal}</p>`;
        break;
      case "led":
        switch (dVal) {
          case 1:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/LED_Light.svg?v=1776217543" alt="" width="" height="" /><p><b>Multicolour LED Light</b><br/>White, Warm White, Yellow</p>`;
            break;
          case 2:
            html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/LED_Light.svg?v=1776217543" alt="" width="" height="" /><p><b>Dual Ambient Indicators</b><br/>White, Warm White, Yellow</p>`;
            break;
        }
        break;
      case "detection":
        html = `<img src="https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Detection.svg?v=1776217543" alt="" width="" height="" /><p><b>Detection</b><br/>${dVal}</p>`;
        break;
    }

    return html;
  }

  function getData() {
    const data = {
      Solaris: {
        airflow: "80% AirFlow Vent",
        type: "Laundry Rack",
        url: "",
        image_url:
          "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_Standard_1.0m_Pearl_White__01.jpg?v=1773626302",
        price: 44900,
        compare_at_price: 0,
        variants: {
          models: ["Standard (1.0m)", "XL (1.3m)"],
          colors: ["Pearl White", "Space Grey"],
        },
        images: {
          "Standard (1.0m) / Pearl White":
            "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_Standard_1.0m_Pearl_White__01.jpg?v=1773626302",
          "Standard (1.0m) / Space Grey":
            "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_Standard_1.0m_Space_Grey__01.jpg?v=1770865739",
          "XL (1.3m) / Pearl White":
            "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_XL_1.3m_Pearl_White__01_1d33b8a5-90be-470c-af5a-128dc06acf79.jpg?v=1773891687",
          "XL (1.3m) / Space Grey":
            "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_XL_1.3m_Space_Grey__01_89afb7e9-0919-48e6-ad33-969167a6a861.jpg?v=1773891687",
        },
        details: {
          aeroFlexMotor: 1,
          heater: 1,
          connectApp: null,
          voiceControl: null,
          aeroFlow: "80% AeroFlow Straight Vent",
          frame: "Aerospace-Grade Aluminium Frame",
          extendableRods: "Yes",
          led: 1,
          detection: "Smart Detection",
        },
      },
      "Solaris Pro": {
        airflow: "100% AirFlow Vent",
        type: "Laundry Rack",
        url: "",
        image_url:
          // "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_Standard_Pro_1.0m_Pearl_White__01.jpg?v=1773626465",
          "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SolarisPro-White-Thumb1_pole_in_GDA_1_afd72e9f-d2a1-49a4-9299-fa998ac2180e.jpg?v=1784189839",
        price: 69900,
        compare_at_price: 0,
        variants: {
          models: ["Standard (1.0m)", "XL (1.3m)"],
          colors: ["Pearl White", "Space Grey"],
        },
        images: {
          // "Standard (1.0m) / Pearl White":
          //   "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_Standard_Pro_1.0m_Pearl_White__01.jpg?v=1773626465",
          // "Standard (1.0m) / Space Grey":
          //   "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_Pro_Standard_1.0m_Space_Grey__01_593ac57a-c6c5-4c55-86f8-67c85b374e1f.jpg?v=1773626465",
          // "XL (1.3m) / Pearl White":
          //   "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_Pro_XL_1.3m_Pearl_White__01_6136e3e1-3c72-4cf8-b44c-1d75db58ee2a.jpg?v=1773891834",
          // "XL (1.3m) / Space Grey":
          //   "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/Solaris_Pro_XL_1.3m_Space_Grey__01_9ce9bed9-b8de-4517-847c-f3b96b422d66.jpg?v=1773891834",
          "Standard (1.0m) / Pearl White":
            "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SolarisPro-White-Thumb1_pole_in_GDA_1_afd72e9f-d2a1-49a4-9299-fa998ac2180e.jpg?v=1784189839",
          "Standard (1.0m) / Space Grey":
            "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SolarisPro-SpaceGrey-Thumb1_pole_in_GDA_13a20207-232d-4353-aa0e-8891475f2b87.jpg?v=1784189838",
          "XL (1.3m) / Pearl White":
            "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SolarisProXL-White-Thumb1_pole_in_GDA_19dedea0-e61c-441b-a25f-804ae300f4a2.jpg?v=1784189839",
          "XL (1.3m) / Space Grey":
            "https://cdn.shopify.com/s/files/1/0703/1498/3651/files/SolarisProXL-SpaceGrey-Thumb1_pole_in_GDA_4c547744-8013-42f6-8b5f-5b4f216351e0.jpg?v=1784189840",
        },
        details: {
          aeroFlexMotor: 2,
          heater: 2,
          connectApp: 1,
          voiceControl: 1,
          aeroFlow: "100% AeroFlow Straight Vent",
          frame: "Aerospace-Grade Aluminium Frame",
          extendableRods: "Yes",
          led: 2,
          detection: "Smart Detection",
        },
      },
    };

    return data;
  }
})();
